'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
exports.checkValidity = void 0;
const checkValidity = ({ target }) => {
  const input = target;
  const valid = input.checkValidity();
  const label = input.closest('label');
  label === null || label === void 0
    ? void 0
    : label.setAttribute('aria-invalid', (!valid).toString());
  if (label) {
    let element =
      label === null || label === void 0
        ? void 0
        : label.querySelector('.error');
    if (!element) {
      const small = document.createElement('small');
      small.classList.add('error');
      label.appendChild(small);
      element = small;
    }
    element.textContent = input.validationMessage;
  }
  return valid;
};
exports.checkValidity = checkValidity;
//# sourceMappingURL=_helpers.js.map
